import React from "react";
import { NavLink, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { NotificationManager } from "react-notifications";
import { Loader } from "../../components/loader";
import { createZipCode, updateZipCode } from "../../actions/customers";
import axios from 'axios';
import qs from 'qs';
import config from "../../config";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";

const $ = window.$;

class AddZipCode extends React.Component {
    constructor(props) {
        super(props);
        this.state = {    
       
            loading : false,         
            ZipCodeId : null,
            zip_code : "",
            link : "",
            zipCode : null,        
            name: "",
            centerZipCode: "",
            distance: 20,
            existsZipcodes: [],
            selectedZipCodes: [],
          };      
}

tableHeaderZipCodeData = [
  {
    dataField: "action",
    text: "Action",
    sort: true,
    headerStyle: (column, colIndex) => {
      return { width: '100px' };
    },
    formatter: (cell, row) => {     
      return (
        <span>
         <input type="checkbox" name="zip_code" id="zip_code" onChange={(e) => this.checkboxHandler(e,row)}/>
        </span>
      );
    }
  },
  {
    dataField: 'zip_code', text: 'Zip Code', sort: true,
    headerStyle: (column, colIndex) => {
      return { width: '100px' };
    }
  },
  {
    dataField: 'name', text: "Current Vet's Name", sort: true,  
    headerStyle: (column, colIndex) => {
      return { width: '220px' };
    }
  },
  {
    dataField: 'link', text: 'Current Affiliate Link', sort: true
  },

];


  closeModal = () => {
    this.setState({zip_code : "", link : "", name : "", ZipCodeId : null},()=>{
      $("#add_zip_code").modal("hide");
    });
    this.props.actionZipCode();
  }

  closeExsitingZipModal = () => {
    this.setState({zip_code : "", link : "", name: "", ZipCodeId : null},()=>{
      $("#exists_zip_code_update").modal("hide");      
    });
    this.props.actionZipCode();
  }

  submitZipCode(e) {  
    e.preventDefault();
    const tempZipCodeArry = this.state.zip_code ? this.state.zip_code.split(','):[]; 
    const zipCodeArry = tempZipCodeArry.filter((element,index) => {
      return element !== '' && tempZipCodeArry.indexOf(element) == index;
    });   
    if (this.state.zip_code && this.state.zip_code.length > 0) { 
      if(this.state.link && this.state.link.length > 0 ){
        if( this.state.link.length <= 1000 ){
          let validLink = this.validateLink(this.state.link);  
            if(validLink){          
              let data = {            
              link : this.state.link,
              PetShopId: this.props.petShop.currentPetshop.id,
              name : this.state.name,
              };
              this.setState({ loading: true });
              if(this.state.ZipCodeId){            
                data.id = this.state.ZipCodeId;
                data.editZipcode = this.state.zip_code;
                data.multiUpdate = false;
                this.props.updateZipCode(data);
                this.props.actionZipCode();
              }else{      
                data.zip_codes_list = zipCodeArry;    
                this.props.createZipCode(data);
              }  
            }
            else{            
              NotificationManager.warning("Link is not valid");
            } 
          }
          else{
            NotificationManager.warning("Maximum character length for the link has exceeded");
          }            
        }  
        else{
            NotificationManager.warning("Affliate Link cannot be empty");
        }                
      } else {             
        NotificationManager.warning("Zip Code cannot be empty");      
      }
  }   

  submitExistingZipCode(e) {      
    e.preventDefault();
    let data = {  
      link : this.state.link,
      PetShopId: this.props.petShop.currentPetshop.id,
      name : this.state.name,
      zipCodes : this.state.selectedZipCodes,
      multiUpdate : true,

     };
     this.props.updateZipCode(data);
   
     } 
  
  getZipCodes = async (e)=>{
    e.preventDefault();    
    try {
       const apiKey = config.zipCodeApi.clientKey; 
       const distance = this.state.distance;
       const centerZipCode = this.state.centerZipCode;   
       let data= qs.stringify({ zip_codes : centerZipCode});
       let tempStringArray = [];
       if(distance && centerZipCode && apiKey){
      let nearZipCodes = await axios.post(`https://www.zipcodeapi.com/rest/${apiKey}/multi-radius.json/${distance}/mile`,data,
       {
        headers:{
          'Content-Type': 'application/x-www-form-urlencoded'
        }
       }   
       );
       if(nearZipCodes && nearZipCodes.data &&  nearZipCodes.data.responses ){     
          nearZipCodes.data.responses.forEach(element => {    
            let zipCodesString = element.zip_codes.join(',');         
            tempStringArray.push(zipCodesString);
          });
          let allZipCodes = tempStringArray.join(',');   
          this.setState({ zip_code : allZipCodes });
      }
    }
    else{
      NotificationManager.warning('Please enter zip codes and distance');
    }
    } catch (error) {     
       NotificationManager.error('The search zip codes were not found');
    }
  }    

  handleChange = event => {
    const value = event.target.value;
    this.setState({   
      [event.target.name]: value
    });
  };

  validateLink = (link) => {   
    if (link.match(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g) !== null){
    return true;
    }
    else {
    return false;
    }
  }

  checkboxHandler =(e,zipCodeObj) =>{
    let selectedZipCodes = this.state.selectedZipCodes;  
    if(e.target.checked){
      selectedZipCodes.push(zipCodeObj);      
    }else{     
      selectedZipCodes.splice(selectedZipCodes.findIndex(item => item.id === zipCodeObj.id), 1);    
    }
    this.setState({ selectedZipCodes : selectedZipCodes});
   
  }

  componentWillReceiveProps = nextProps => {  

    if (nextProps.selectedZipCodeLinkData 
            && nextProps.selectedZipCodeLinkData.id
            && nextProps.selectedZipCodeLinkData.id !== this.state.ZipCodeId ) {          
            
             this.setState({
              ZipCodeId : nextProps.selectedZipCodeLinkData.id,
              zip_code : nextProps.selectedZipCodeLinkData.zip_code,
              link : nextProps.selectedZipCodeLinkData.link,
              name : nextProps.selectedZipCodeLinkData.name,
              }, () => {               
                $("#add_zip_code").modal("show");                
             });

    }
      
    if (nextProps.createdZipcode && this.props.createdZipcode !== nextProps.createdZipcode) { 
      
      if(nextProps.createdZipcode && nextProps.createdZipcode.existsZipcode && nextProps.createdZipcode.existsZipcode.length >0 ){
        NotificationManager.success("Zip Codes Added"); 
        $("#exists_zip_code_update").modal("show");  
        this.setState({ existsZipcodes : nextProps.createdZipcode.existsZipcode, loading: false});
        $("#add_zip_code").modal("hide");
      }  
      else{
         NotificationManager.success("Zip Code Added");       ;        
         $("#add_zip_code").modal("hide");
         this.props.actionZipCode();       
         this.setState({ zip_code: "", link : "", ZipCodeId : null, name :"", centerZipCode:"", distance:"", loading: false }); 
      } 
    }

    if(nextProps.createZipcodeError && nextProps.createZipcodeError !== this.props.createZipcodeError){
      const AlreadyZipcodeAvailable = 'Zip Code Already Exists';  
      if(nextProps.createZipcodeError.message && nextProps.createZipcodeError.message === AlreadyZipcodeAvailable){
        NotificationManager.error(nextProps.createZipcodeError.message);
        this.setState({ loading: false });
      }
    }

    if (nextProps.updatedZipcode && this.props.updatedZipcode  !== nextProps.updatedZipcode) {      
        this.setState({ zip_code: "", link : "", name: "", ZipCodeId : null, loading: false, selectedZipCodes:[] });            
        NotificationManager.success("Zip Code Updated");      
        $("#add_zip_code").modal("hide");
        $("#exists_zip_code_update").modal("hide");
        this.props.actionZipCode();  
    }

    if (nextProps.updatedZipcodeError && this.props.updatedZipcodeError  !== nextProps.updatedZipcodeError){ 
      const AlreadyZipcodeAvailable = 'Zip Code Already Exists'; 
      if (nextProps.updatedZipcodeError.message && (nextProps.updatedZipcodeError.message === AlreadyZipcodeAvailable)) {
        NotificationManager.error(nextProps.updatedZipcodeError.message);
        this.setState({ loading: false });
      } else {
        NotificationManager.error("An error occurred while updating the zip code" );
      }     
    }
  }

render() {
  const {  
    link,zip_code,name,existsZipcodes,distance
  } = this.state;
    return (
    <div>
      <div
        className="modal fade show"
        id="add_zip_code"
        tabIndex="-1"
        role="dialog"
        data-backdrop="static"
      >
           <div className="modal-dialog" role="document">
          <div className="modal-content">
            <form className="m-form">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  {!this.state.ZipCodeId  ? "Add New Veterinarian" : "Edit Veterinarian"}
                </h5>
                <button
                  type="button"
                  className="close"
                  onClick={this.closeModal}
                  aria-label="Close"
                >
                  <span aria-hidden="true">×</span>
                </button>
            </div>
            <div className="modal-body">
                <div className="row">
                  <div className="col-xl-12">
                    <div className="m-form__section m-form__section--first">
                    <div className="form-group m-form__group row">
                         <label className="col-xl-3 col-lg-3 col-form-label">
                             Name                             
                          </label>
                          <div className="col-xl-9 col-lg-9">
                          <input
                            type="text"
                            name="name"                       
                            onChange={e => this.handleChange(e)}
                            className="form-control m-input"
                            value={name}
                            placeholder="Please enter name of veterinarian"
                          />                     
                          </div>
                        </div>
                        <div className="form-group m-form__group row">
                         <label className="col-xl-3 col-lg-3 col-form-label">
                           Affliate Link 
                          </label>
                          <div className="col-xl-9 col-lg-9">              
                            <textarea
                              className="form-control m-input"
                              name="link"
                              onChange={e => this.handleChange(e)}  
                              value={link}
                              id="exampleTextarea"
                              rows="4"
                              placeholder="Please enter link to veterinarian's affiliate offer letter"
                              >
                            </textarea>  
                            <div className='d-flex justify-content-end'>                                
                              <div>
                                  <span className='pet-description-word-count'>{link && link.trim().length > 0 ? link.trim().length: 0}/1000</span>
                              </div>                     
                            </div>
                            <div className='d-flex justify-content-end'>  
                              <span
                                className={link && link.trim().length > 1000 ?                                         
                                  "m-form__help_danger justify-content-end"
                                  :"display-none"}
                                >
                                Link character length exceeds maximum
                              </span> 
                            </div>
                         </div>
                        </div>
                    {!this.state.ZipCodeId  ? 
                    <div className="form-group m-form__group row border border-secondary border-3 rounded py-4 g-1">                     
                      <label className="col-xl-3 col-lg-3 col-form-label">
                        Search
                      </label>
                      <div className="col-xl-4 col-lg-4">
                        <input
                          type="text"
                          name="centerZipCode"                       
                          onChange={e => this.handleChange(e)}
                          className="form-control m-input"
                         
                        />
                        <div className="pt-2">
                        <span>Center Zip Code</span>
                        </div>
                      </div>
                      <div className="col-xl-3 col-lg-3">
                        <input
                          type="number"
                          name="distance"                                           
                          onChange={e => this.handleChange(e)}
                          className="form-control m-input"
                          value={distance}
                                                    
                        />
                         <div className="pt-2">
                          <span> Distance(mile) </span>
                        </div>
                      </div>
                      <div className="col-xl-2 col-lg-2">                    
                        <a
                         href="#" 
                         class="btn btn-info m-btn m-btn--icon m-btn--icon-only"
                         onClick={(e) =>{ this.getZipCodes(e); } }>
													<i className ="fa fa-search"></i>
												</a>
                      </div>               
                    </div>:null }
                    <div className="form-group m-form__group row">
                         <label className="col-xl-3 col-lg-3 col-form-label">
                             Zip Codes 
                          </label>
                          <div className="col-xl-9 col-lg-9">
                          {!this.state.ZipCodeId  ? 
                            <textarea
                              className="form-control m-input"
                              name="zip_code"
                              onChange={e => this.handleChange(e)}  
                              value={zip_code}
                              id="exampleTextarea"
                              rows="3"
                              placeholder="Please enter zip codes"
                              >
                            </textarea>:
                            <input
                             type="text"
                             name="zip_code"
                             className="form-control m-input"
                             onChange={e => this.handleChange(e)}  
                             value={zip_code}
                            />        
                          }             
                          </div>
                        </div>                   
                                        
                    </div>
                   </div>
                </div>
            </div>   
            <div className="modal-footer">
            {this.state.loading == false ? (
                  <div>
                    <button
                      type="button"
                      className="btn btn-secondary m-btn--pill mx-2"
                      onClick={this.closeModal}
                    >
                      Close
                      </button>
                    <button
                      onClick={(e) =>{ this.submitZipCode(e); } }
                      type="submit"
                      className="btn btn-primary m-btn--pill"
                    >
                      Submit
                      </button>
                  </div>
                ) : (
                    <div className="center-row">
                      <Loader size={50} />
                    </div>
                  )}
            </div>     
        </form>
        </div>
        </div>
      </div>  
      <div
        className="modal fade show"
        id="exists_zip_code_update"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLongTitle"
        aria-hidden="true"
       
      >
        <div className="modal-dialog modal-lg modal-scrollable-dialog" role="document">
          <div className="modal-content modal-scrollable-body">
            <form className="m-form">
              <div className="modal-header">
                <span className="btn btn-danger m-btn m-btn--icon m-btn--icon-only m-btn--pill mr-2 mr-2"><i className ="fas fa-exclamation" style={{fontSize:"22px"}}></i></span>
                <h5 className="modal-title pt-2" id="exampleModalLabel">
                   Overlapping Zip Codes Detected!
                </h5>
                <button
                  type="button"
                  className="close"
                  onClick={this.closeExsitingZipModal}
                  aria-label="Close"
                >
                  <span aria-hidden="true">×</span>
                </button>
            </div>
            <div className="modal-body">
                <div className="row">
                  <div className="col-xl-12 pb-2">                    
                    <h5>Please choose to update these zip codes with new veterinarian's information OR keep it unchanged.</h5>   
                  </div>
                  <div className="col-xl-12 my-3"></div>
                  <div className="col-xl-12">
                    <div className="m-form__section m-form__section--first">
                    <div className="form-group m-form__group row pb-0 pt-2"> 
                      <span className="col-xl-2 col-lg-2">
                         <strong>New Vet's Name : </strong>                    
                      </span> 
                      <div className="col-xl-3 col-lg-3">              
                         {name}
                      </div>    
                      <span className="col-xl-2 col-lg-2">
                           <strong> New Affiliate Link :</strong>   
                        </span>
                        <div className="col-xl-4 col-lg-4">  
                         {link}          
                        </div> 
                    </div>
                    <div className="form-group m-form__group row pt-0">                     
                      <div className="col-xl-12 col-lg-12">
                        <ToolkitProvider
                          keyField="id"
                          data={ existsZipcodes }
                          columns={this.tableHeaderZipCodeData}
                          search
                          hover={true}                        
                        >
                          {props => (
                            <div>
                              <div className="px-0 mb-4 search-bar">                              
                              </div>                 
                                <BootstrapTable
                                  classes="petTable"
                                  {...props.baseProps}  
                                  pagination={paginationFactory()}                           
                                />                        
                            </div>
                          )}
                        </ToolkitProvider>  
                                      
                     </div>
                    </div>                           
                    </div>
                   </div>
                </div>
            </div> 
            <div className="modal-footer">           
                  <div>
                    <button
                      type="button"
                      className="btn btn-secondary m-btn--pill mx-2"
                      onClick={this.closeExsitingZipModal}
                    >
                     Keep It Unchange
                    </button>
                    <button
                      onClick={(e) =>{ this.submitExistingZipCode(e); } }
                      type="submit"
                      className="btn btn-primary m-btn--pill"
                    >
                    Update
                    </button>
                  </div>              
            </div>                   
           </form>
          </div>
        </div>
      </div>  
       
    </div>  
    )
}

}

const mapStateToProps = state => ({
    petShop: state.petShopReducer,
    createdZipcode: state.customersReducer.createdZipcode,
    createZipcodeError: state.customersReducer.createZipcodeError,
    updatedZipcode : state.customersReducer.updatedZipcode,
    updatedZipcodeError : state.customersReducer.updatedZipcodeError
  });
  
  const mapDispatchToProps = dispatch => ({

    createZipCode: data =>{
      dispatch(createZipCode(data));
    },

    updateZipCode: (id,data) =>{
      dispatch(updateZipCode(id,data));
    }

  });
  
  export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(AddZipCode)
  );